module.exports = __webpack_public_path__ + "static/media/sms-email-notification.87ee6076.png";